export default function PathTransformer(
  path,
  languageSlug,
  defaultLanguage,
  languagesEnabled,
  isRelative = true,
) {
  if (!path) return null

  const languagesEnabledRegExp = languagesEnabled.map(
    l => new RegExp(l.replace(`_`, `-`)),
  )

  const basePath = languageSlug === defaultLanguage ? `` : `/${languageSlug}`

  let filteredSlug = path.startsWith("homepage") ? `` : path

  let matchedLanguage = languagesEnabledRegExp.find(re => re.test(filteredSlug))
  if (matchedLanguage) {
    filteredSlug = filteredSlug.replace(
      `-${matchedLanguage.source.replace(`/`, ``)}`,
      ``,
    )
  }

  if (isRelative && filteredSlug.startsWith(basePath))
    return filteredSlug.slice(basePath.length)

  return filteredSlug
}
